<template>
  <div class="mv-wrapper">
    <!-- <div class="mv-top">
      <b-button class="mv-top-btn" @click="$bvModal.show(`add-category`)" variant="link">
        <b-icon-plus />Add Categories
      </b-button>
      <b-button @click="$bvModal.show('preview Qrcode')" class="mv-top-btn" variant="link">
        <b-icon-eye-fill />Preview QR Code
      </b-button>
    </div>-->
    <div v-if="menu && menuId" class="menu-title">
      {{menu.menu_name}}
      <span>
        <b-button @click="$bvModal.show('preview Qrcode')" class="mv-top-btn" variant="link">
          <b-icon-eye-fill />Preview QR Code
        </b-button>
      </span>
    </div>
    <div class="mv-body row">
      <div class="mv-body-left col-md-9 order-1 order-md-0">
        <template v-if="menu && menuId">
          <div
            class="no-data"
            v-if="menu.categories.length===0"
          >There are no categories in this menu yet. Click above to add category</div>
          <div v-else class="categories">
            <draggable
              v-model="menu.categories"
              :disabled="!enabled"
              class="list-group"
              ghost-class="ghost"
              @start="dragging = true"
              @change="checkEnd"
              handle=".handle"
            >
              <template v-for="(category) in categories">
                <div :key="category.id" class="card-cat position-relative">
                  <span @click="removeCategory(category.id)" class="cancel-cat position-absolute">X</span>
                  <CategoryCard :editable="false" :index="category.id" :category="category" />
                </div>
              </template>
            </draggable>
          </div>
        </template>
      </div>
      <div class="mv-body-right col-md-3 order-0 order-md-1">
        <b-button
          @click="addCategoryToMenu"
          class="mcat-top-btn mt-0 w-100"
          variant="info"
          :disabled="selectedItems.length<1"
        >
          <b-icon-plus />Add Category(s)
        </b-button>
        <MultipleSelect
          name="select-item"
          v-model="selectedItems"
          placeholder="Type to Search Items"
          :options="formatOptions"
          :isLoading="isLoading"
          :onsearch="searchCategories"
          :selectedItems="selectedItems"
          :rules="'required'"
          trackBy="name"
        >
          <template v-slot:options="slotProps">
            <div class="option-name">{{slotProps.options.option.name}}</div>
          </template>
        </MultipleSelect>
        <div class="preview-items mt-4 mb-4 pb-4">
          <template v-for="(item,index) in selectedItems">
            <div :key="'selected'+index" class="selected-options mb-2">
              <div @click="removeItem(index)" class="cancel-wrapper">X</div>

              <div class="selected-cat">{{item.name}}</div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <validation-observer v-slot="{invalid}">
      <b-modal
        v-if="menu"
        :ok-disabled="invalid"
        @ok="addCategory"
        id="add-category"
        size="sm"
        title="Add Category"
      >
        <TextInput
          :rules="`required|CategoryName:${menuId}`"
          placeholder="Enter Category"
          v-model="form.category"
        />
        <TextInput placeholder="Enter Description" v-model="form.description" />
      </b-modal>
    </validation-observer>
    <b-modal id="preview Qrcode" size="sm" title="Preveiw Qrcode">
      <img v-if="menu !==null" :src="menu.qrcodeUrl" alt />
      <template v-slot:modal-footer="{  }">
        <Botton
          size="sm"
          variant="success"
          :isLoading="generatingPdf"
          :onclick="generateReport"
          text="Download"
        />
        <Botton
          size="sm"
          variant="info"
          :isLoading="regenerating"
          :onclick="regenerate"
          text="Regenerate"
        />
        <!-- <b-button size="sm" variant="success" @click="generateReport">Download</b-button>
        <b-button size="sm" variant="info" @click="regenerate">Regenerate</b-button>-->
      </template>
    </b-modal>
    <vue-html2pdf
      v-if="menu && userProfile"
      :show-layout="false"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      :filename="`${this.userProfile.company_name} - ${menu.menu_name} - QrCode`"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      @hasGenerated="toggleGeneratingPdf"
      ref="html2Pdf"
    >
      <section v-if="userProfile && menu" slot="pdf-content">
        <div class="pr-img-wrapper">
          <img src="/img/bg5.jpg" alt class="pr-logo" />
        </div>
        <p class="pr-company_name">{{userProfile.company_name}}</p>
        <div class="pr-img-wrapper">
          <img :src="menu.qrcodeUrl" alt class="pr-qrcode" />
        </div>
        <p class="pr-info">Open Your Phone Camera And Scan Qr Code</p>
        <p
          class="pr-info"
        >Or Visit the Link: {{`${baseurl}/${this.userProfile.username}/${this.menu.slug}`}}</p>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import CategoryCard from "../pages/components/CategoryCard";
import { auth } from "../Firebase/firebase";
import draggable from "vuedraggable";
import { BIconPlus, BIconEyeFill } from "bootstrap-vue";
import { baseurl } from "../helpers/helper";
import Botton from "../pages/components/Botton";
import TextInput from "./components/Inputs/TextInput";
import { ValidationObserver } from "vee-validate";
import MultipleSelect from "./components/Inputs/MultipleSelect";
import VueHtml2pdf from "vue-html2pdf";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { mapGetters } from "vuex";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
  components: {
    CategoryCard,
    draggable,
    BIconPlus,
    BIconEyeFill,
    VueHtml2pdf,
    Botton,
    TextInput,
    ValidationObserver,
    MultipleSelect
  },
  data() {
    return {
      menuId: "",
      currentMenu: "",
      form: {
        category: "",
        description: ""
      },
      enabled: true,
      dragging: false,
      baseurl: "",
      generatingPdf: false,
      regenerating: false,
      selectedItems: [],
      isLoading: false
    };
  },
  methods: {
    async fetchMenu() {
      const menu = await this.$store.dispatch("Menu/fetchMenu", {
        menuId: this.menuId
      });
      this.currentMenu = menu;
      this.fetchCategories();
    },
    addCategory() {
      if (this.form.category) {
        this.$store.dispatch("Menu/createCategory", {
          menuId: this.menuId,
          form: this.form
        });
      }
    },
    checkEnd() {
      this.$store.dispatch("Menu/editCategory", {
        categories: this.menu.categories,
        menuId: this.menuId
      });
    },
    async fetchUserProfile() {
      const userProfile = await this.$store.dispatch(
        "Auth/fetchUserProfile",
        auth.currentUser
      );
      return userProfile;
    },
    async regenerate() {
      this.regenerating = true;
      const qrcodeUrl = `https://chart.googleapis.com/chart?cht=qr&chs=400x400&chl=${encodeURIComponent(
        `${baseurl}/${this.userProfile.username}/${this.menu.slug}`
      )}`;
      this.$store
        .dispatch("Menu/updateQrcode", {
          qrcodeUrl,
          menuId: this.menuId
        })
        .then(() => {
          this.regenerating = false;
          this.$bvModal.hide("preview Qrcode");
        });
    },
    generateReport() {
      this.toggleGeneratingPdf();
      this.$refs.html2Pdf.generatePdf();
    },
    toggleGeneratingPdf() {
      this.generatingPdf = !this.generatingPdf;
    },
    async searchCategories(query) {
      this.searchingCategories = true;
      const response = await this.$store.dispatch("Category/searchCategories", {
        limit: 20,
        query
      });
      this.searchingCategories = false;
      return response;
    },
    async fetchCategories() {
      this.searchingCategories = true;
      const response = await this.$store.dispatch("Menu/fetchMenuCategories", {
        categories: this.menu.categories
      });
      this.searchingCategories = false;
      return response;
    },
    removeItem(index) {
      this.selectedItems.splice(index, 1);
    },
    async addCategoryToMenu() {
      const categories = this.selectedItems.map(item => {
        return item.id;
      });

      await this.$store.dispatch("Menu/addCategoryToMenu", {
        menuId: this.$route.params.menuId,
        categories
      });

      this.selectedItems = [];
    },
    removeCategory(categoryId) {
      const newCategory = this.menu.categories.filter(
        category => category != categoryId
      );
      this.$store.dispatch("Menu/removecategoryFromMenu", {
        newCategory,
        menuId: this.menu.id
      });
    }
  },
  computed: {
    /* ...mapGetters({
      categories:"Menu/menuCategories"
    }), */
    menu() {
      return this.$store.state.Menu.currentMenu;
    },
    userProfile() {
      return this.$store.state.Auth.userProfile;
    },
    categories() {
      return this.$store.state.Menu.menuCategories;
    },
    searchedCategories() {
      return this.$store.state.Category.searchCategories;
    },
    formatOptions() {
      const newOptions = this.searchedCategories.filter(item => {
        return !this.menu.categories.includes(item.id);
      });
      return newOptions;
    }
  },
  mounted() {
    this.menuId = this.$route.params.menuId;
    this.baseurl = baseurl;
    this.fetchMenu();
  }
};
</script>

<style>
.mv-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
}

.mv-wrapper .mv-top {
  display: flex;
  justify-content: flex-end;
}

.mv-wrapper .mv-top .mv-top-btn {
  color: #2ca8ff;
  margin: 0;
  padding: 0 10px;
}

.mv-wrapper .menu-title .mv-top-btn:hover {
  color: #2ca8ff;
}

.mv-wrapper .menu-title {
  font-size: 18px;
  font-weight: 600;
}

.mv-wrapper .categories {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 30px;
}

.pr-logo {
  width: 100px;
  height: 100px;
  margin: 40px auto 20px;
}
.pr-img-wrapper {
  display: flex;
  justify-content: center;
}
.pr-company_name {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
}
.pr-qrcode {
  width: 400px;
  height: 400px;
  margin: 0px auto;
}
.pr-info {
  text-align: center;
  font-size: 16px;
  font-weight: 400;
}

.cancel-cat{
  z-index: 2;
  top: 10px;
  right: 20px;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
}
</style>